import Component from './Users.container';

export default Component;
